import { urlResource } from '../../data/remote/urlResource';
export class Sku {
    groupOrdinal: number;
    logoPath: string;
    sku: string;
    skuGroup: string;
    skuName: string;
    skuOrdinal: number;

    constructor({
        group_ordinal = undefined,
        logo_path = undefined,
        sku = undefined,
        sku_group = undefined,
        sku_name = undefined,
        sku_ordinal = undefined
    }: any) {
        this.groupOrdinal = group_ordinal;
        this.logoPath = logo_path ? urlResource(logo_path) : "";
        this.sku = sku;
        this.skuGroup = sku_group;
        this.skuName = sku_name;
        this.skuOrdinal = sku_ordinal;

    }
}